import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { MarkAsEditableAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function markAsEditableReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== MarkAsEditableAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isEditable) {
    return state;
  }

  return {
    ...state,
    isEditable: true,
    isInert: false,
  };
}
